import React from "react";
import { InputMascaraDinamica } from "./InputMascaraDinamica";

export type InputCpfCnpjProps = {
    cpfCnpj: string,
    onCpfCnpjModificado: (cpfCnpj: string) => void
    emitirComMascara?: boolean
    name?: string
    id?: string
    className?: string
    onKeyPress?: (event: React.KeyboardEvent) => any
    disabled?: boolean
    autoFocus?: boolean
    teclaDeAtalho?: string
    style?: React.CSSProperties
}

const MASCARA_CPF  = "999.999.999-99"
const MASCARA_CNPJ = "SS.SSS.SSS/SSSS-99"

export const InputCpfCnpj = (props: InputCpfCnpjProps) => <InputMascaraDinamica
    name={props.name}
    id={props.id}
    className={props.className}
    type="text"
    mascaras={props.cpfCnpj?.length == 18 
        ? [MASCARA_CNPJ, MASCARA_CPF] 
        : [MASCARA_CPF, MASCARA_CNPJ]}
    emitirComMascara={props.emitirComMascara === undefined || props.emitirComMascara === true}
    onValorModificado={props.onCpfCnpjModificado}
    valor={props.cpfCnpj}
    autoFocus={props.autoFocus}
    teclaDeAtalho={props.teclaDeAtalho}
    disabled={props.disabled}
    habilitaEventoChange={true}
    style={props.style ?? { minHeight: "26px" }}
    onKeyPress={props?.onKeyPress} />

